import gql from 'graphql-tag';

export const CtgLoyaltyAssignPersonalizedOffer = gql`
  mutation ctgLoyaltyCreatePersonalizedOffer(
    $loyaltyId: String!
    $offerTemplateId: String!
    $offerConfigId: String!
    $cognitoId: String!
    $reason: String!
    $refundedItems: [RefundedItemsInput]
    $orderId: String
    $comments: String
    $metadata: [CtgLoyaltyMetadataEntryInput!]
  ) {
    ctgLoyaltyCreatePersonalizedOffer(
      loyaltyId: $loyaltyId
      offerTemplateId: $offerTemplateId
      offerConfigId: $offerConfigId
      cognitoId: $cognitoId
      reason: $reason
      refundedItems: $refundedItems
      orderId: $orderId
      comments: $comments
      metadata: $metadata
    ) {
      configId
      id
      loyaltyId
      offerTemplateId: sourceId
    }
  }
`;
